declare namespace $ {

	type $mol_button_download__blob_shm_hitalama_settings_transfer_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_transfer['exported_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__file_name_shm_hitalama_settings_transfer_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_transfer['exported_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_button_download__title_shm_hitalama_settings_transfer_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $shm_button_open__title_shm_hitalama_settings_transfer_4 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_open['title'] >
	>
	type $shm_button_open__multiple_shm_hitalama_settings_transfer_5 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_button_open['multiple'] >
	>
	type $shm_button_open__files_shm_hitalama_settings_transfer_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_transfer['import_files'] >
		,
		ReturnType< $shm_button_open['files'] >
	>
	type $mol_text__text_shm_hitalama_settings_transfer_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_transfer['status'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_hitalama_settings_transfer extends $mol_list {
		exported_blob( ): any
		exported_file_name( ): string
		Export_all( ): $mol_button_download
		import_files( next?: readonly(File)[] ): readonly(File)[]
		Import_all( ): $shm_button_open
		status( next?: string ): string
		Status( ): $mol_text
		rows( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=transfer.view.tree.d.ts.map